import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedNumber } from 'react-intl';

const FormatInteger = injectIntl(({ value, ...customProps }) => {
  return (
    <FormattedNumber
      value={Number(value || 0) || 0}
      minimumIntegerDigits={1}
      minimumFractionDigits={0}
      maximumFractionDigits={0}
      useGrouping={true}
      style={`decimal`}
      {...customProps}
    />
  );
});

FormatInteger.propTypes = {
  intl: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default FormatInteger;
